module.exports = __webpack_public_path__ + "images/bd86a6834e13275e26a918b914489765.svg";